import { idb } from "../../db/index.ts";
import { MAX_LEAGUES } from "../../../common/economy.ts";

// How many leagues the user currently has.
export const numLeagues = async (): Promise<number> =>
	(await idb.meta.getAll("leagues")).length;

// Throw if creating another league would exceed the hard cap. The user must
// delete an existing league to free a slot. Enforced in the worker so it can't
// be bypassed from the UI.
export const assertUnderLeagueCap = async (): Promise<void> => {
	if ((await numLeagues()) >= MAX_LEAGUES) {
		throw new Error(
			`You can have at most ${MAX_LEAGUES} leagues at once. Delete one to create another.`,
		);
	}
};
